import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_DOCUMENT_LIST_TKT_STORE_NAME, GetDocumentListTktState } from './get-document-list-tkt.state';

/** Select GetDocumentListTkt State */
export const selectGetDocumentListTktState = createFeatureSelector<GetDocumentListTktState>(
  GET_DOCUMENT_LIST_TKT_STORE_NAME
);

/** Select GetDocumentListTkt isPending status */
export const selectGetDocumentListTktIsPendingStatus = createSelector(
  selectGetDocumentListTktState,
  (state) => !!state.isPending
);

/** Select GetDocumentListTkt isFailure status */
export const selectGetDocumentListTktIsFailureStatus = createSelector(
  selectGetDocumentListTktState,
  (state) => !!state.isFailure
);
